import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import actionBe from 'utils/mw/actionBe.util';

const beCancelPayment = actionBe('beCancelPayment', ({ L, AT, paymentIntentId, readerId, umsg }) => {
  if (!fromAnyToTrimmed(readerId)) L.warn('()', 'Invalid readerId:', readerId);

  // NOTE: BE needs this to be either a string or null, no empty string
  const intentId = fromAnyToTrimmed(paymentIntentId) || null;

  return endpoint(H.post, 'payments/stripe/cancel/payment/:salonId/:readerId/', {
    AT,
    params: { readerId },
    data: { intent_id: intentId },
    umsg,
  });
});

// noinspection JSUnusedGlobalSymbols
export default beCancelPayment;
